module.exports = __webpack_public_path__ + "static/media/Pe-icon-7-stroke.dedf2698.svg";